import Api from '../Api';

import { url } from './config';
import { ServiceAddressToOption } from './types';

const api = new Api<ServiceAddressToOption>(url);

export default api;
